<template>
  <div>
    <v-row>
      <v-col class="d-flex flex-1 justify-space-between pb-5">
        <span class="header bold text-tcdc-green">{{onlineExhibition[`title_${lang}`]}}</span>
        <ShareButton mode="online-exhibition"></ShareButton>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="d-flex flex-1 align-center justify-space-between">
          <div class="d-flex flex-1" v-if="onlineExhibition.start_date && onlineExhibition.end_date || onlineExhibition.branch_id">
            <div class="pr-3 d-flex align-center" v-if="onlineExhibition.start_date && onlineExhibition.end_date">
              <img src="../../assets/icons/sorts/calendar.png" class="eventdetail-card-logo mr-4" />
              <span
                      class="bold text-uppercase text-tcdc-green"
              >{{onlineExhibition.start_date}} - {{onlineExhibition.end_date}}
              </span>
            </div>
            <div class="d-flex align-center" v-if="onlineExhibition.branch_name">
              <img src="../../assets/icons/marker.png" class="eventdetail-card-logo mr-4" />
              <span class="bold text-uppercase text-tcdc-green">{{onlineExhibition.branch_name}}</span>
            </div>
          </div>
          <div class="align-center">
            <span class="text-tcdc-grey1 bold mr-4">{{$t('onlineEx.publish')}} {{onlineExhibition[`publish_date_${lang}`]}}</span>
            <img src="../../assets/icons/generals/view.png" class="tcdc-view-icon mr-2" />
            <span class="text-tcdc-grey1 bold">{{onlineExhibition.viewer}}</span>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row class="my-5">
      <v-col>
        <div
          class="vhtml"
          v-html="onlineExhibition[`detail_${lang}`]"
        ></div>
      </v-col>
    </v-row>
    <v-row class="mb-5">
      <v-col>
        <GreenButton label="visit website" v-if="onlineExhibition.attached_website_th || onlineExhibition.attached_website_en" @onPress="openLink(onlineExhibition[`attached_website_${lang}`])"  />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pb-0">
        <v-img :src="onlineExhibition.cover_image" aspect-ratio="1.7"></v-img>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import GreenButton from "../../components/buttons/GreenButton";
import ShareButton from "../buttons/ShareButton";
import { mapState } from 'vuex';
export default {
  components: {
    GreenButton,
    ShareButton
  },
  methods: {
    openLink(link) {
      if (link) {
        window.open(link);
      }
    }
  },
  computed: {
    ...mapState({
      lang: state => state.Branch.lang,
      onlineExhibition: state => state.Article.onlineExhibition
    })
  }
};
</script>

<style lang="scss" scoped>
.eventdetail-card-logo {
  height: 25px;
  object-fit: contain;
}
.tcdc-exhibition-green-background {
  background-color: $tcdcGreen;
}
.tcdc-view-icon {
  height: 15px;
  object-fit: contain;
}
</style>
